export const LAYOUT_INDEX = { header: 4, body: 3, footer: 2 }
